import {Component, Input} from '@angular/core';
import {AppConstants} from '@app/shared/util/app-constants';
import { TicketComment } from '@shared/services';

@Component({
  selector: 'app-ticket-comment-author-logo',
  templateUrl: './ticket-comment-author-logo.component.html',
  styleUrls: ['./ticket-comment-author-logo.component.scss'],
  standalone: false
})
export class TicketCommentAuthorLogoComponent {

  @Input() comment: TicketComment;
  @Input() fontSize = AppConstants.DEFAULT_COMMENT_LOGO_FONT_SIZE;

  constructor() { }
}
